import { createDarkTheme, createLightTheme, type BrandVariants, type Theme } from '@fluentui/react-components';

// Tokens taken from arm.tellec.com so TELLEC apps look the same.
export const brand = {
  primary: '#071952',
  secondaryAccessible: '#078092',
  light: '#EBF4F6',
  chrome: '#006600',
  chromeHover: '#005200',
  chromePressed: '#003d00',
  chromeText: '#FFFFFF',
  neutral10: '#FAF9F8',
  text: '#242424',
  textMuted: '#555555',
  warning: '#FCB900',
} as const;

export const fontFamily = "'Barlow', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

const ramp: BrandVariants = {
  10: '#020611',
  20: '#04102b',
  30: '#061640',
  40: '#071952',
  50: '#0a2a63',
  60: '#0b3d74',
  70: '#0a5f80',
  80: '#078092',
  90: '#1f9aa9',
  100: '#37b7c3',
  110: '#5cc4ce',
  120: '#80d1d8',
  130: '#a4dee3',
  140: '#c7eaed',
  150: '#ebf4f6',
  160: '#f5fafb',
};

const shared = {
  fontFamilyBase: fontFamily,
  fontFamilyNumeric: fontFamily,
  borderRadiusMedium: '4px',
  borderRadiusLarge: '5px',
};

// Same overrides as ARM: primary buttons use the green chrome colour.
export const lightTheme: Theme = {
  ...createLightTheme(ramp),
  ...shared,
  colorNeutralForeground1: brand.text,
  colorNeutralBackground2: brand.neutral10,
  colorBrandBackground: brand.chrome,
  colorBrandBackgroundHover: brand.chromeHover,
  colorBrandBackgroundPressed: brand.chromePressed,
  colorBrandBackgroundSelected: brand.chromeHover,
  colorCompoundBrandBackground: brand.chrome,
  colorCompoundBrandBackgroundHover: brand.chromeHover,
  colorCompoundBrandBackgroundPressed: brand.chromePressed,
  colorCompoundBrandStroke: brand.chrome,
  colorCompoundBrandStrokeHover: brand.chromeHover,
  colorCompoundBrandStrokePressed: brand.chromePressed,
};

// ARM has no dark theme; this one keeps the green actions and uses the
// navy end of the brand ramp for surfaces.
const dark = createDarkTheme(ramp);
export const darkTheme: Theme = {
  ...dark,
  ...shared,
  colorNeutralBackground1: '#061640',
  colorNeutralBackground2: '#04102b',
  colorNeutralBackground3: '#0a2a63',
  colorNeutralStroke1: '#4d6a93',
  colorNeutralStroke2: '#12306b',
  colorBrandBackground: brand.chrome,
  colorBrandBackgroundHover: '#0a7a0a',
  colorBrandBackgroundPressed: brand.chromeHover,
  colorBrandBackgroundSelected: '#0a7a0a',
  colorCompoundBrandBackground: '#2e9e2e',
  colorCompoundBrandBackgroundHover: '#3cb43c',
  colorCompoundBrandBackgroundPressed: '#268a26',
  colorCompoundBrandStroke: '#2e9e2e',
  colorBrandForeground1: '#5cc4ce',
  colorBrandForegroundLink: '#5cc4ce',
  colorBrandForegroundLinkHover: '#80d1d8',
};
